export function init() {
    const spinner = document.querySelector('.js-compass-spinner');

    document.addEventListener('mousemove', e => {
        let spinnerRect = spinner.getBoundingClientRect();
        
        var centerX     = (window.scrollX + spinnerRect.left) + (spinnerRect.width / 2),
            centerY     = (window.scrollY + spinnerRect.top) + (spinnerRect.height / 2),
            radians     = Math.atan2(e.pageX - centerX, e.pageY - centerY),
            degree      = (radians * (180 / Math.PI) * -1) + 90;
        
        spinner.style.transform = 'rotate(' + degree + 'deg)';
    });
}
